import { render } from "./App.vue?vue&type=template&id=de587d1c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=de587d1c&lang=scss"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__